module.exports = __webpack_public_path__ + "img/shop-by-style-filter-black.3e1f0070.png";